module.exports = __webpack_public_path__ + "img/3.738f8246.png";